function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.5 -2.5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16.273,20.667V18.778A3.8,3.8,0,0,0,12.455,15H4.818A3.8,3.8,0,0,0,1,18.778v1.889",
  transform: "translate(0 -0.667)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "a",
  cx: 3.818,
  cy: 3.778,
  rx: 3.818,
  ry: 3.778,
  transform: "translate(4.818 3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.864,20.674V18.785A3.785,3.785,0,0,0,20,15.13",
  transform: "translate(-0.864 -0.674)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16,3.13a3.768,3.768,0,0,1,0,7.319",
  transform: "translate(-0.682 -0.007)"
}));

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.1fc6609f.svg";
export { ForwardRef as ReactComponent };